'use client'

import { useAuth } from '@/Auth/useAuth'
import { UserIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'
import { useState } from 'react'
import { LoginModal } from '../LoginModal'

export const LoginAccountButton = () => {
  const { isAuthenticated, isResolved } = useAuth()
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  return (
    <>
      <LoginModal 
        isLoginOpen={isLoginOpen} 
        setIsLoginOpen={setIsLoginOpen}
        redirectToAccount={true}
      />
      <div className="flex justify-end">
        {!isResolved ? (
          <div className="h-8 w-8 bg-gray-200 rounded-full animate-pulse" />
        ) : !isAuthenticated ? (
          <div
            className="inline-flex min-h-[44px] min-w-[44px] cursor-pointer items-center justify-center rounded-md border-none px-3 py-2 text-sm font-semibold text-vi-gray hover:text-vi-red ring-gray-300 hover:bg-gray-50"
            onClick={() => setIsLoginOpen(!isLoginOpen)}
            title="Login"
          >
            Login
          </div>
        ) : (
          <Link
            href="/account"
            prefetch={false}
            className="inline-flex min-h-[44px] min-w-[44px] cursor-pointer items-center justify-center rounded-md border-none px-2 py-2 text-sm font-semibold text-vi-gray ring-gray-300 hover:bg-gray-50 hover:text-vi-red"
          >
            <UserIcon className="h-6 w-6" aria-hidden="true" />
          </Link>
        )}
      </div>
    </>
  )
}
